export default __webpack_public_path__ + "static/media/cross.59c54673.svg";